import React from "react";

// Trang tĩnh: liệt kê đúng các ràng buộc/luật đang áp dụng trong bộ giải
// CP-SAT (happyschool-api/scheduler/solve_timetable.py) — chỉ để XEM, không
// sửa được ở đây (muốn đổi luật phải sửa code bộ giải). Giữ đồng bộ tay với
// file đó mỗi khi thêm/sửa luật.

// Nguyên văn "Điều kiện xếp TKB của THPT" nhà trường đưa ra (nguồn gốc các
// luật kỹ thuật bên dưới) — ghi lại đây để đối chiếu, không phải luật do bộ
// giải tự suy ra. Đã đối chiếu với cấu hình/code hiện tại (ghi chú "✅ Đã
// áp dụng" / "⚠️ Chỉ đáp ứng 1 phần" ngay sau từng điều).
const SCHOOL_POLICY_RULES = [
  {
    text: "GV có giảng dạy bộ môn thì phải xếp dạy lớp mình chủ nhiệm.",
    status: "✅ Đã áp dụng (ràng buộc cứng)",
    note: "Khi GVCN cũng là GV chính của môn đó ở lớp mình chủ nhiệm, bộ giải BẮT BUỘC xếp đủ 100% số tiết (không cho thiếu) — nếu thật sự không giải được (vd GV bận trùng hết giờ lớp có), bộ giải tự cô lập riêng lớp đó để báo lỗi rõ, không làm sập cả bản.",
  },
  {
    text: "Mỗi môn không xếp dạy quá 3 tiết/buổi học, riêng Toán/Văn phải xếp được ít nhất 1 buổi 2 tiết liền nhau (kiểm tra 90 phút).",
    status: "✅ Đã áp dụng",
    note: "Phạt nặng (15000đ) khi 1 môn dồn từ 3 tiết/buổi trở lên (mọi môn); Toán/Văn có cơ chế riêng khuyến khích 1 lần liền 2 tiết/tuần.",
  },
  {
    text: "Các buổi học phải liên tục từ tiết 1-4 hoặc tiết 1-5, không để trống tiết; không để HS đến trường chỉ học 1-2 tiết.",
    status: "✅ Đã áp dụng",
    note: "Luật cứng \"lấp kín từ đầu buổi\" (xem mục Ràng buộc CỨNG bên dưới) đã đảm bảo không có tiết trống xen giữa.",
  },
  {
    text: "12A1, 12A2, 12A3, 12A4 (tổ hợp Toán-Văn-Sử-Địa): Toán 8, Văn 8, Sử 4, Địa 4 tiết/tuần.",
    status: "✅ Đã áp dụng",
  },
  {
    text: "12A5, 12A8, 12A10, 12A11 (tổ hợp Toán-Văn-Sử-Công nghệ): Toán 8, Văn 8, Sử 4, Công nghệ 4 tiết/tuần.",
    status: "✅ Đã áp dụng",
  },
  {
    text: "12A7, 12A12, 12A13 (tổ hợp Toán-Văn-Sử-KTPL): Toán 8, Văn 8, Sử 4, GDKT&PL 4 tiết/tuần.",
    status: "✅ Đã áp dụng",
  },
  {
    text: "Các môn còn lại khối 12: 2 tiết/tuần; riêng Tiếng Anh 1 tiết/tuần.",
    status: "✅ Đã áp dụng",
  },
  {
    text: "Khối 10, 11: Toán và Văn mỗi môn 7 tiết/tuần; Lịch sử kỳ 1 xếp 3 tiết/tuần (có thêm chuyên đề), kỳ 2 xếp 2 tiết/tuần; các môn còn lại 2 tiết/tuần.",
    status: "✅ Đã áp dụng (đang ở kỳ 1)",
  },
];

const HARD_RULES = [
  "Không giáo viên nào dạy 2 nơi cùng lúc.",
  "Mỗi lớp, mỗi tiết chỉ học tối đa 1 môn.",
  "Chỉ xếp môn văn hoá vào đúng buổi được đánh dấu \"văn hoá\" của lớp đó (không xếp vào buổi nghề / pháp luật / nghỉ).",
  "Lấp kín từ đầu buổi — không để trống 1 tiết giữa buổi rồi học tiếp (trừ 2 tiết đầu/cuối buổi nghề dùng làm dự phòng khi thiếu tiết).",
  "Tiết đầu và tiết cuối của 1 buổi nghề: chỉ được dùng TỐI ĐA 1 trong 2 làm văn hoá dự phòng (để buổi nghề luôn giữ đúng 4 tiết liền, không bị rời khối).",
  "Mỗi môn tối đa 3 tiết trong 1 buổi (áp dụng chung mọi môn).",
  "Số tiết liền nhau không nghỉ giữa (\"liền khối\"), tối đa: môn thường phải TÁCH TIẾT (không được 2 tiết liền) — trừ Văn/Toán (liền tới 2), GV thỉnh giảng thêm khít lịch (liền tới 3), và GV thỉnh giảng (dù không khít lịch) hoặc GV \"nhà xa\" (liền tới 2, đỡ đi lại nhiều lần).",
  "Tối đa 6 tiết/ngày cho 1 môn theo mặc định — trừ khi lớp có cấu hình riêng \"Tối đa tiết/ngày\".",
  "Không môn nào được xếp VƯỢT số tiết cần theo cấu hình (cấm tuyệt đối, dù giáo viên còn dư giờ).",
];

// weight: số càng LỚN thì bộ giải càng ưu tiên tránh vi phạm luật đó khi
// phải đánh đổi (đây là bài toán tối ưu đa mục tiêu, không phải luật cứng).
const SOFT_RULES = [
  { weight: 500, text: "Giữ nguyên các ô đã đúng từ 1 lần chạy trước (\"lockedCells\") nếu có truyền vào — hiện KHÔNG có màn hình/route nào bật tính năng này, cơ chế nằm sẵn trong bộ giải nhưng chưa dùng." },
  { weight: 300, text: "GV \"nhà xa\" (gom lịch): phạt mỗi NGÀY phải đến trường — để dồn hết tiết vào càng ít ngày càng tốt." },
  { weight: 250, text: "GV \"nhà xa\" lên trường nguyên ngày mà chỉ dạy đúng 1 tiết (đi cả buổi/ngày chỉ dạy 1 tiết là quá phí)." },
  { weight: 200, text: "Để trống 1 tiết trong buổi văn hoá của 1 lớp — đây là phạt áp dụng cho MỌI ô nên thực tế là ưu tiên cao nhất: thà lấp bằng môn khác còn hơn để trống." },
  { weight: "100 × mức ưu tiên GV", text: "Thiếu tiết so với số tiết cần theo cấu hình (mức ưu tiên GV càng cao — dạy càng nhiều lớp/tiết — thì phạt thiếu càng nặng, được xếp trước)." },
  { weight: 100, text: "GV \"nhà xa\": phạt mỗi BUỔI có mặt ở trường trong 1 ngày (khuyến khích gom cả ngày vào 1 buổi nếu được)." },
  { weight: 70, text: "Khoảng trống giữa các tiết trong ngày của GV ĐÃ khai báo bận giờ nào đó (kiểu \"dạy — nghỉ — dạy\")." },
  { weight: 60, text: "1 môn của 1 lớp đáng lẽ gọn được trong 1 buổi nhưng bộ giải phải xé thêm sang buổi khác trong tuần." },
  { weight: 45, text: "Khoảng trống giữa các tiết trong ngày của GV KHÔNG khai báo bận (nhẹ hơn GV có bận, vì họ vốn ít bị ràng buộc lịch)." },
  { weight: 35, text: "GV cả ngày chỉ dạy đúng 1 tiết (lên trường 1 tiết là phí công đi lại) — GV nội trú/ở gần trường được MIỄN phạt này." },
  { weight: 15, text: "Văn/Toán không xếp liền được 2 tiết trong buổi (chỉ là ưu tiên nhỏ, không bắt buộc)." },
];

const SEARCH_ORDER = [
  "1. GV bó hẹp lịch (\"tight\" — còn ≤3 ngày rảnh/tuần) — quyết định lịch của nhóm này trước tiên.",
  "2. Lớp khối 12 (được đánh dấu ưu tiên khối) — trừ phần đã thuộc nhóm 1.",
  "3. GV ưu tiên cao (dạy ≥30 tiết/tuần hoặc ≥5 lớp) nhưng KHÔNG thuộc nhóm \"tight\" — trừ phần đã thuộc nhóm 1, 2.",
  "4. GV còn lại có khai báo lịch bận — trừ phần đã thuộc 3 nhóm trên.",
];

const TEACHER_FLAGS = [
  { name: "tight (bó hẹp lịch)", desc: "Còn ≤3 ngày rảnh/tuần — được xếp quyết định sớm nhất, và môn của họ được nới trần lên tới 3 tiết/buổi." },
  { name: "highPriority (ưu tiên cao)", desc: "Dạy ≥30 tiết/tuần hoặc ≥5 lớp, nhưng không \"tight\" — phạt thiếu tiết rất nặng, xếp quyết định sớm (sau tight/khối 12)." },
  { name: "thinhGiangTight (thỉnh giảng + khít lịch)", desc: "Vừa \"tight\" vừa là GV thỉnh giảng — được dạy LIỀN TỚI 3 TIẾT/buổi (không bắt tách), để dồn đủ tiết vào rất ít buổi hiếm hoi họ có mặt." },
  { name: "commutePairOk (thỉnh giảng hoặc nhà xa)", desc: "GV thỉnh giảng (dù không khít lịch) HOẶC được đánh dấu \"nhà xa\" — được dạy LIỀN TỚI 2 TIẾT/buổi (không bắt tách), đỡ phải đi lại nhiều lần trong 1 buổi." },
  { name: "compact (nhà xa)", desc: "Bị phạt theo số ngày/buổi phải đến trường (300đ/ngày, 100đ/buổi) — khuyến khích bộ giải dồn hết tiết vào càng ít lần đi lại càng tốt." },
  { name: "resident (nội trú / gần trường)", desc: "Được MIỄN phạt \"lên trường chỉ dạy đúng 1 tiết\" (35đ) — vì không tốn công đi lại nên dạy ít tiết cũng không sao." },
];

const section = { marginBottom: 28 };
const h3Style = { margin: "0 0 10px 0", fontSize: 16 };
const introStyle = { color: "#6b7280", fontSize: 13, marginTop: 0, marginBottom: 16 };
const listStyle = { margin: 0, paddingLeft: 20, lineHeight: 1.7, fontSize: 14 };
const cardStyle = { background: "#fff", borderRadius: 8, padding: "16px 20px", boxShadow: "0 1px 2px rgba(0,0,0,0.06)" };
const weightBadge = {
  display: "inline-block",
  minWidth: 40,
  textAlign: "center",
  background: "#0ea5a3",
  color: "#fff",
  borderRadius: 6,
  padding: "1px 8px",
  fontWeight: 700,
  fontSize: 12,
  marginRight: 8,
};

const HappySchoolScheduleRules = () => {
  return (
    <div>
      <p style={introStyle}>
        Toàn bộ luật xếp thời khoá biểu (bộ giải CP-SAT) đang áp dụng — chỉ để xem, không sửa được ở đây.
        Muốn đổi luật cần sửa code bộ giải (<code>solve_timetable.py</code>).
      </p>

      <div style={section}>
        <h3 style={h3Style}>📋 Điều kiện xếp TKB của THPT (yêu cầu gốc từ nhà trường)</h3>
        <div style={cardStyle}>
          <ol style={listStyle}>
            {SCHOOL_POLICY_RULES.map((r, i) => (
              <li key={i} style={{ marginBottom: 8 }}>
                {r.text}
                <div style={{ fontSize: 12, color: r.status.startsWith("✅") ? "#059669" : "#b45309", marginTop: 2 }}>
                  {r.status}{r.note ? ` — ${r.note}` : ""}
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>

      <div style={section}>
        <h3 style={h3Style}>🔒 Ràng buộc CỨNG (luôn đúng tuyệt đối)</h3>
        <div style={cardStyle}>
          <ol style={listStyle}>
            {HARD_RULES.map((r, i) => (
              <li key={i}>{r}</li>
            ))}
          </ol>
        </div>
      </div>

      <div style={section}>
        <h3 style={h3Style}>⚖️ Mục tiêu tối ưu (phạt điểm, có trọng số — số càng lớn càng ưu tiên tránh)</h3>
        <div style={cardStyle}>
          <ol style={listStyle}>
            {SOFT_RULES.map((r, i) => (
              <li key={i} style={{ marginBottom: 4 }}>
                <span style={weightBadge}>{r.weight}</span>
                {r.text}
              </li>
            ))}
          </ol>
        </div>
      </div>

      <div style={section}>
        <h3 style={h3Style}>🔍 Thứ tự ưu tiên khi tìm lời giải</h3>
        <p style={introStyle}>
          Đây KHÔNG phải phạt điểm — là thứ tự bộ giải quyết định lịch của từng nhóm trước, để nhóm khó xếp nhất không bị nhóm dễ xếp "giành" mất chỗ trống.
        </p>
        <div style={cardStyle}>
          <ol style={listStyle}>
            {SEARCH_ORDER.map((r, i) => (
              <li key={i} style={{ listStyleType: "none", marginBottom: 6 }}>{r}</li>
            ))}
          </ol>
        </div>
      </div>

      <div style={section}>
        <h3 style={h3Style}>🏷️ Các cờ (nhãn) riêng theo từng giáo viên</h3>
        <div style={cardStyle}>
          <ol style={listStyle}>
            {TEACHER_FLAGS.map((f, i) => (
              <li key={i} style={{ marginBottom: 8 }}>
                <strong>{f.name}</strong> — {f.desc}
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  );
};

export default HappySchoolScheduleRules;
